export default {
  Before: 'before',
  After: 'after'
}
